import React, { useEffect, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import AppsOutlinedIcon from '@material-ui/icons/AppsOutlined';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import MenuIcon from '@material-ui/icons/Menu';
import UserPanel from './UserPanel';
import LanguageMenu from './LanguageMenu';
import { useHistory } from 'react-router';
import Notification from './Notification';
import CloudConsoleLogo from 'legacy-components/icons/CloudConsoleLogo';
import CompanyLogo from 'legacy-components/icons/CompanyLogo';
import { RelatedWebApps } from './RelativeApps';
import { useDispatch, useSelector } from 'react-redux';
import { EnvironmentSelector } from './environment-selector/EnvironmentSelector';
import MainHelper from 'pages/home/helper/MainHelper';
import { useFeatureToggler } from 'libs/utils/generic/ConsoleFeatureToggler';
import TeamSelector from './team-selector/TeamSelector';
import TeamSelectorUserOnBoarding from './team-selector/TeamSelectorUserOnboarding';
import { isNewConsoleSepFlow } from './environment-selector/ENV_CONSTANTS';
import { ConsoleSeperationBanner } from 'pages/home/ConsoleSeperationBanner';
import { useRole } from 'libs/security/authorization/Permission';
import TeamServices from 'pages/home/team/TeamService';
import { useAsyncAction } from 'modus/components/form/async-actions/AsyncAction';
import Loader from 'modus/components/misc/Loader';
import * as actions from "../store/actions/actions";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginTop: 0,
      width: "inherit"
    },
    appBar: {
      background: "#fff",
      color: "#000",
      userSelect: "none"
    },
    toolBar: {
      width: "inherit",
      margin: 0,
      minHeight: '56px'
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1
    },
    searchDesktop: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      }
    },
    settings: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'block'
      },
    },

  }),
);

interface HeaderProps {
  toggleNav: () => void
  toggleNavSize: () => void
}
const Header: React.FC<HeaderProps> = ({ toggleNav, toggleNavSize }) => {
  const classes = useStyles();
  const [openHelper, setOpenHelper] = useState(false);
  const history = useHistory();
  const { isLegacyFeatureUrl } = useFeatureToggler();
  const onHelpClicked = () => {
    setOpenHelper(true);
  }
 

  const toggleNavigationPanel = () => {
    toggleNavSize();
  }
  const toggleMobileNavigationPanel = () => {
    toggleNav();
  }
  let search;
  // search = (<SearchReceiver className={classes.searchDesktop}/>);
  let settings = (
    <div className={classes.settings} >
      <RelatedWebApps/>
      <IconButton onClick={onHelpClicked}>
        <HelpOutlineIcon />
      </IconButton>
      <Notification />
      <MainHelper open={openHelper} handleClose={() => { setOpenHelper(false) }} />
      <LanguageMenu />
      <IconButton><AppsOutlinedIcon /></IconButton>
      <UserPanel />
    </div>
  );
  /**
   * Hiding Search and Settings temporarily until features are implemented
   */
  settings = (
    <div className={classes.settings} >
      <RelatedWebApps/>
      <Notification />
      <IconButton onClick={onHelpClicked}>
        <HelpOutlineIcon />
      </IconButton>
      <MainHelper open={openHelper} handleClose={() => { setOpenHelper(false) }} />
      <UserPanel />
    </div>
  );

  const onHomeClicked = () => {
    history.push('/home')
  }

  const globalUser = useSelector((globalState: any) => globalState.userManager);

  let group;
  if (globalUser) {
    group =
      globalUser.role === "SECTOR ADMIN" ? globalUser.sector : globalUser.teamDisplayName;
  }
  
  const isNewOnboardingFlow =
  process.env.REACT_APP_USER_ONBOARDING_FLOW === "true";

  const [, userRoleState,] = useRole();
  const dispatch = useDispatch();
    const { state, subscribe } = useAsyncAction(() =>
      TeamServices.getUsersTeamByUuid(userRoleState?.value?.uuid as string)
    );

      useEffect(() => {
        if (!subscribe || !userRoleState?.value?.uuid) {
          return;
        }
        subscribe();
      }, [userRoleState?.value?.uuid]);

       useEffect(() => {
            if(!state || !dispatch || !state?.value) {
              return;
            }
            dispatch({
              type: actions.storeMyTeamList,
              payload: state?.value,
            });
          },[state?.value, dispatch]);
  
  return (
    <div className={classes.root}>
        <AppBar position="relative" className={classes.appBar}>
          <Toolbar className={classes.toolBar}>
            <IconButton
              edge="start"
              className="desktop-view"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleNavigationPanel}
            >
              <MenuIcon />
            </IconButton>
            <IconButton
              edge="start"
              className="mobile-view"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleMobileNavigationPanel}
            >
              <MenuIcon />
            </IconButton>
            <CompanyLogo />
            <CloudConsoleLogo onClick={onHomeClicked} />
               {state?.loading && (
                        <div className="team-selection-loader">
                                  <Loader showBackDrop={true} />
                                </div>
                      )}
            {process.env.REACT_APP_HEADER_SHOW_STAGE_ICON === "true" && (
              <img
                src="/assets/stage.png"
                alt="Staging Environment"
                style={{ width: '58px', marginLeft: '10px' }}
              />
            )}
              {isNewOnboardingFlow? (<TeamSelectorUserOnBoarding state={state} subscribe={subscribe} newUser={false}/>) :(<TeamSelector group={group}/>)}            {isNewConsoleSepFlow  ? (<></>) :  (!isLegacyFeatureUrl() && (<EnvironmentSelector/>))}
            <span className={classes.title} />
            {search}
            {settings}
          </Toolbar>
        </AppBar>
        <ConsoleSeperationBanner />
    </div>
  );
}


export default Header;
